<template>
  <div :class="$style['gallery']">
    <button
      v-for="(item, index) in items"
      :key="item.id"
      type="button"
      :class="$style['gallery__item']"
      :aria-label="`Foto ${index + 1} van ${items.length} groot bekijken`"
      @click="event => showImage(event, index)">
      <NuxtImg
        :src="item.filename"
        preset="galleryThumb"
        :alt="item.alt || item.name || title || ''"
        format="webp"
        loading="lazy" />
    </button>
  </div>
  <Transition name="gallery" :enter-active-class="$style['gallery__viewer--enter']" :leave-active-class="$style['gallery__viewer--leave']">
    <GalleryViewer v-if="activeImage" :class="$style['gallery__viewer']" :items="items" :active="activeImage" @close="activeImage = null" />
  </Transition>
</template>
<script setup lang="ts">
const activeImage: Ref<number | null> = ref(null)
defineProps<{
  items: Array<any>,
  title?: string,
}>()

const originX: Ref<number | null> = ref(null)
const originY: Ref<number | null> = ref(null)

const showImage = (event: MouseEvent, index: number) => {
  activeImage.value = index + 1
  originX.value = event.pageX
  originY.value = event.pageY
}

</script>
<style module>
/* A contact sheet: tight square thumbnails that open the viewer */
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(14rem, 45%), 1fr));
  gap: var(--spacing-s);
}

.gallery__viewer {
  transition: transform var(--duration-micro-fast) var(--easing-transition);
  transform: scale(1);
}

.gallery__viewer--enter {
  transform: scale(0);
}

.gallery__viewer--leave {
  transform: scale(0);
}

.gallery__item {
  position: relative;
  display: flex;
  padding: 0;
  border: 0;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  background: var(--background-raised);
  cursor: zoom-in;
}

.gallery__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 600ms var(--stage-ease), opacity 300ms;
}

.gallery__item:hover img {
  transform: scale(1.05);
}

.gallery__item:focus-visible {
  outline: 0.1875rem solid var(--primary-color);
  outline-offset: -0.1875rem;
}

@media (prefers-reduced-motion: reduce) {
  .gallery__item img {
    transition: none;
  }
}
</style>
